// extracted by mini-css-extract-plugin
export default {"description":"szcau","addNumberButton":"LcztT","closeLink":"j6I1z","tableWrapper":"J7mfS","numberList":"HuOxw"};